<template>
    <div class="roast-select">
        <div v-for="(roast, index) in roastItems" :key="index">
            <input type="radio" name="roast-radio"
                   :value="roast.VALUE"
                   :checked="roast.VALUE === $attrs.value"
                   :id="`roast-${index}`"
            >
            <label class="roast-select__radio" :for="`roast-${index}`">
                <img
                    :src="iconPath"
                    :alt="roast.VALUE"
                >
                <img v-if="roast.VALUE.toLowerCase() === 'эспрессо'"
                    :src="iconPath"
                    :alt="roast.VALUE"
                >
                <span>{{ roast.PRINT_VALUE }}</span>
            </label>
        </div>
    </div>
</template>

<script>
import { ICONS_PATH } from '../../../constants';

export default {
    name: 'roast-select',

    data() {
        return {
            iconName: 'icon-coffee-bean-full.svg',
        };
    },

    props: {
        roastItems: {
            type: Array,
            required: true,
        },
    },

    methods: {
        bindEvents() {
            $(this.$el).on('change', ({ target }) => {
                this.$emit('input', target.value);
            });
        },
    },

    computed: {
        iconPath() {
            return `${ICONS_PATH}${this.iconName}`;
        },
    },

    mounted() {
        this.bindEvents();
    },
};
</script>
